// extracted by mini-css-extract-plugin
export default {"confluenceHistogram":"confluenceHistogram-y4QE8","histogram":"histogram-YeAjf","yAxis":"yAxis-o9ufG","hideTickLine":"hideTickLine-TWkLv","label":"label-JR9HD"};